import type { ReactNode } from 'react'

import { type AccordionProps } from '@graftcode/design-system'

import { createTitleWithBadge } from '@/core/utils/createTitleWithBadge'

/**
 * Builds an AccordionProps object for the design-system accordion: id, title (optionally with badge), content, and toggle handler.
 */
export const createAccordion = (
  id: string,
  title: ReactNode,
  content: ReactNode,
  isOpen: boolean,
  onToggle: (itemId: string) => void,
  badge?: string
): AccordionProps => {
  const titleSlot = badge ? createTitleWithBadge(title, badge, 'accordion__badge') : title

  return {
    id,
    titleSlot,
    content,
    onCollapseChange: () => onToggle(id),
  }
}
